import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { useSelectedDealer } from "components";
import "modules/AgreementsDashboard/AgreementsDashboard.scss";
import { AgreementsModal, AgreementsTable } from "modules/AgreementsDashboard/components";
import { useAgreementsQuery } from "modules/AgreementsDashboard/hooks";
import { toISOString } from "utils/dateHelperFunctions";

import type { CommunicationAgreement } from "models";

export const AgreementsDashboard = () => {
  const [showAgreementsModal, setShowAgreementsModal] = useState<number | null>(null);
  const { data: agreements, isFetching: isFetchingAgreements } = useAgreementsQuery();
  const { selectedDealer } = useSelectedDealer();

  const handleShowCreateAgreementsModal = () => setShowAgreementsModal(-1);
  const handleCloseAgreementsModal = () => setShowAgreementsModal(null);
  const handleShowEditAgreementsModal = (id: number) => setShowAgreementsModal(id);

  const defaultFormValues: CommunicationAgreement = {
    id: -1,
    dealer_id: selectedDealer?.id || 0,
    name: "",
    text: "",
    visible_online_check_in: false,
    visible_keylocker_check_in: false,
    visible_kiosk_check_in: false,
    visible_desk_check_in: false,
    visible_desk_check_out: false,
    visible_customcom: false,
    optional_online_check_in: false,
    optional_keylocker_check_in: false,
    optional_kiosk_check_in: false,
    optional_desk_check_in: false,
    optional_desk_check_out: false,
    optional_customcom: false,
    created_on: toISOString(new Date()),
    updated_on: toISOString(new Date()),
    parent_id: null,
    deleted: false
  };

  const agreement = showAgreementsModal === -1 ? defaultFormValues : (agreements?.find(a => a.id === showAgreementsModal) ?? defaultFormValues);

  return (
    <div className="AgreementsDashboard">
      <div className="add-button-container">
        <Button basic icon className="add-btn" onClick={handleShowCreateAgreementsModal}>
          <Icon className="plus" />
        </Button>
      </div>
      <AgreementsTable handleShowEditAgreementsModal={handleShowEditAgreementsModal} />
      <AgreementsModal isOpen={!!showAgreementsModal} isFetchingAgreements={isFetchingAgreements} onClose={handleCloseAgreementsModal} agreement={agreement} />
    </div>
  );
};
